var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"border physical-activity-goal-setting"},[_c('p-a-goal-setting-tabs'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }